// import {
//   Box,
//   Menu,
//   MenuButton,
//   MenuList,
//   MenuItem,
//   Input,
//   Text,
//   Button,
// } from "@chakra-ui/react";
// import { useState } from "react";
// import { ChevronDownIcon } from "../../feather";

// interface Option {
//   label: string;
//   value: string;
// }

// interface CustomSelectProps {
//   label?: string;
//   placeholder?: string;
//   options: Option[];
//   value: string | null;
//   onChange: (value: string) => void;
// }

// const CustomSelect: React.FC<CustomSelectProps> = ({
//   label,
//   placeholder = "Select",
//   options,
//   value,
//   onChange,
// }) => {
//   const [search, setSearch] = useState("");

//   const filtered = options.filter((item) =>
//     item.label.toLowerCase().includes(search.toLowerCase())
//   );

//   const selectedLabel =
//     options.find((item) => item.value === value)?.label || placeholder;

//   return (
//     <Box>
//       {label && (
//         <Text mb={1} fontWeight="500" fontSize="sm">
//           {label}
//         </Text>
//       )}

//       <Menu matchWidth>
//         <MenuButton
//           as={Button}
//           justifyContent="space-between"
//           rightIcon={<ChevronDownIcon />}
//           variant="outline"
//           w="100%"
//           fontSize="sm"
//           textAlign="left"
//           fontWeight="500"
//           color={value ? "textPrimary.500" : "textSecondary.500"}
//           borderColor="strokePrimary.500"
//           bg="white"
//           _hover={{
//             bg: "white",
//             borderColor: "primary.500",
//             color: "textPrimary.500",
//           }}
//           _focus={{
//             borderColor: "secondary.500",
//           }}
//           _active={{
//             bg: "white",
//             borderColor: "primary.500",
//           }}
//         >
//           {selectedLabel}
//         </MenuButton>

//         <MenuList maxH="200px" overflowY="auto">
//           {/* Search Bar */}
//           <Box
//             p={2}
//             borderBottomWidth="1px"
//             borderBottomColor="strokePrimary.500"
//           >
//             <Input
//               placeholder="Search..."
//               size="sm"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               _focus={{
//                 borderColor: "secondary.500",
//                 boxShadow: "0 0 0 1px rgba(66, 153, 225, 0.6)",
//               }}
//             />
//           </Box>

//           {/* Options */}
//           {filtered.length > 0 ? (
//             filtered.map((item) => (
//               <MenuItem
//                 key={item.value}
//                 onClick={() => {
//                   onChange(item.value);
//                   setSearch("");
//                 }}
//                 fontWeight={value === item.value ? "500" : "400"}
//                 color={value === item.value ? "primary.500" : "textSecondary.500"}
//                 _hover={{
//                   bg: "secondary.500",
//                   color: "primary.600",
//                 }}
//                 _focus={{
//                   bg: "secondary.500",
//                   color: "primary.600",
//                 }}
//               >
//                 {item.label}
//               </MenuItem>
//             ))
//           ) : (
//             <Box p={3} color="textSecondary.500" textAlign="center" fontSize="sm">
//               No results
//             </Box>
//           )}
//         </MenuList>
//       </Menu>
//     </Box>
//   );
// };

// export default CustomSelect;

import {
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Input,
  Text,
  Button,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { ChevronDownIcon } from "../../feather";

interface Option {
  label: string;
  value: string;
}

interface CustomSelectProps {
  label?: string;
  placeholder?: string;
  options: Option[];
  value: string | null;
  onChange: (value: string) => void;

  /* NEW */
  onSearch?: (search: string) => void;
  isLoading?: boolean;
  isRequired?: boolean;
  error?: string;
  isSearchable?: boolean;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  label,
  placeholder = "Select",
  options,
  value,
  onChange,
  onSearch,
  isLoading = false,
  isRequired = false,
  error,
  isSearchable = true,
}) => {
  const [search, setSearch] = useState("");
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  // Debounce backend search
  useEffect(() => {
    if (!onSearch || !isSearchable) return;

    const timer = setTimeout(() => {
      onSearch(search);
    }, 400);

    return () => clearTimeout(timer);
  }, [search, onSearch, isSearchable]);

  // If backend search exists → don't filter locally
  const filtered =
    !isSearchable || onSearch
      ? options
      : options.filter((item) =>
          item.label.toLowerCase().includes(search.toLowerCase())
        );

  // const selectedLabel =
  //   options.find((item) => item.value === value)?.label || placeholder;

  /* Sync selected option when options load */
  useEffect(() => {
    if (!value) return;

    const found = options.find((opt) => opt.value === value);
    if (found) {
      setSelectedOption(found);
    }
  }, [options, value]);

  const selectedLabel = selectedOption?.label || placeholder;


  return (
    <Box>
      {/* ===== Label ===== */}
      {label && (
        <Text mb={1} fontWeight="500" fontSize="sm">
          {label}
          {isRequired && (
            <Text as="span" color="red.500" ml={1}>
              *
            </Text>
          )}
        </Text>
      )}

      <Menu matchWidth>
        <MenuButton
          as={Button}
          justifyContent="space-between"
          rightIcon={<ChevronDownIcon />}
          variant="outline"
          w="100%"
          fontSize="sm"
          textAlign="left"
          fontWeight="500"
          color={value ? "textPrimary.500" : "textSecondary.500"}
          borderColor={error ? "red.500" : "strokePrimary.500"}
          bg="white"
          _hover={{
            bg: "white",
            borderColor: error ? "red.500" : "primary.500",
            color: "textPrimary.500",
          }}
          _focus={{
            borderColor: error ? "red.500" : "secondary.500",
          }}
          _active={{
            bg: "white",
            borderColor: error ? "red.500" : "primary.500",
          }}
        >
          {selectedLabel}
        </MenuButton>

        <MenuList maxH="220px" overflowY="auto">
          {/* ===== Search Bar ===== */}
          {isSearchable && (
            <Box
              p={2}
              borderBottomWidth="1px"
              borderBottomColor="strokePrimary.500"
            >
              <Input
                placeholder="Search..."
                size="sm"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                _focus={{
                  borderColor: "secondary.500",
                  boxShadow: "0 0 0 1px rgba(66, 153, 225, 0.6)",
                }}
              />
            </Box>
          )}

          {/* ===== Options ===== */}
          {isLoading ? (
            <Box p={3} textAlign="center" fontSize="sm">
              Loading...
            </Box>
          ) : filtered.length > 0 ? (
            filtered.map((item) => (
              <MenuItem
                key={item.value}
                onClick={() => {
                  setSelectedOption(item);
                  onChange(item.value);
                  setSearch("");
                }}
                fontWeight={value === item.value ? "500" : "400"}
                color={
                  value === item.value
                    ? "primary.500"
                    : "textSecondary.500"
                }
                _hover={{
                  bg: "secondary.500",
                  color: "primary.600",
                }}
                _focus={{
                  bg: "secondary.500",
                  color: "primary.600",
                }}
              >
                {item.label}
              </MenuItem>
            ))
          ) : (
            <Box
              p={3}
              color="textSecondary.500"
              textAlign="center"
              fontSize="sm"
            >
              No results
            </Box>
          )}
        </MenuList>
      </Menu>

      {/* ===== Error Message ===== */}
      {error && (
        <Text mt={1} fontSize="xs" color="red.500">
          {error}
        </Text>
      )}
    </Box>
  );
};

export default CustomSelect;
